function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6 7.30001L10.7 0.60001C10.3 0.20001 9.4 -0.29999 7.7 0.40001C6.7 0.80001 5.6 1.60001 4.6 2.60001C2.7 4.50001 1.2 7.30001 2.6 8.70001L9.3 13.6C9.6 13.9 10 14 10.4 14C11.5 14 12.9 13.1 14 12C14.7 11.3 15.3 10.5 15.7 9.70001C16.3 8.40001 15.9 7.60001 15.6 7.30001ZM6 4.00001C7.5 2.50001 8.8 2.00001 9.2 2.00001C9.2 2.40001 8.7 3.70001 7.2 5.20001C5.7 6.70001 4.4 7.20001 4 7.20001C4.1 6.70001 4.5 5.40001 6 4.00001Z",
  fill: "#002A95"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 14C0 12.9 2 10 2 10C2 10 4 12.9 4 14C4 15.1 3.1 16 2 16C0.9 16 0 15.1 0 14Z",
  fill: "#002A95"
});

var SvgTheme = function SvgTheme(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Theme.fff52899.svg";
export { ForwardRef as ReactComponent };